import { useEffect, useState, useContext } from "react";
import {baseURL, LEHGU_LOGO_URL, erfahrenSieMehrPageID, jwtName} from "../../constants"
import Cookies from 'universal-cookie';
import {jwtDecode} from "jwt-decode"
import { useNavigate } from 'react-router-dom';
import {postRequest} from "../../utils/requestFunctions"
import {PageTreeContext} from "../../context/pageTreeContext"
import {logout} from "../../utils/functions"
import Footer from "../Footer"


export default function Login (){
    const cookies = new Cookies()
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const navigate = useNavigate();
    const [error, setError] = useState()
    const pageTreeContextValue = useContext(PageTreeContext);


    useEffect(() => {
      logout()
      pageTreeContextValue.amILoggedIn() && logout()
    }, [])

    useEffect(() => {
      logout()
      pageTreeContextValue.amILoggedIn() && pageTreeContextValue.forceLogout()
    }, [pageTreeContextValue.loggedIn])



    const login = (jwtToken) => {
      const decoded = jwtDecode(jwtToken)
      cookies.set(jwtName, jwtToken, {
        path: "/",
        expires: new Date(decoded.exp * 1000),
      })
      navigate('/start')
    }

    const submitLogin = async (e) => {
        e.preventDefault()
        try {
          // params: postRequest(jwt, url, data)
          const response = await postRequest(null, baseURL, {
            username:  username, 
            password:  password 
          })
          response && login(response.data.jwt)
          } catch (error) {
            console.error("error", error.message);
            setError(error.message)
          }
    }

    const handleUsernameChange = (e) => {
        setUsername(e.target.value)
    }
    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
    }

    const erfahrenSieMehr = (e) => {
      e.preventDefault()
      navigate("/lerneinheiten/page/" + erfahrenSieMehrPageID)
  }


    




    return (
        <div className="flex min-h-full flex-1 flex-col justify-center  ">
          <div className="bg-gradient-to-r from-blue-100 via-blue-300 to-blue-500 hero"></div>
          <div className="sm:mx-auto sm:w-full sm:max-w-sm flex justify-center">
            <img
              className="loginLogo "
              src={LEHGU_LOGO_URL}
              alt=""
            />

          </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm loginWrapper">
          <form className="space-y-6" action="#" method="POST">
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                E-Mail 
              </label>
              <div className="mt-2">
                <input
                onChange={handleUsernameChange}
                  id="email"
                  name="email"
                  autoComplete="email"
                  required
                  className="pl-3 pr-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Passwort
                </label>
              </div>
              <div className="mt-2">
                <input
                onChange={handlePasswordChange}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>


            <div>
              <button
              onClick={submitLogin}
                type="submit"
                className="loginButton flex w-full justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  
                focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 "
              >
                EINLOGGEN
              </button>
            </div>

            <div className="erfahrenSieMehrWrapper ">
              <button
              onClick={erfahrenSieMehr}
                type="submit"
                className="erfahrenSieMehrButton flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                ERFAHREN SIE MEHR!
              </button>
            </div>

            {error && 
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-center" role="alert">
              Leider war Ihr Login nicht erfolgreich.
            </div>
            }
          </form>

 
        </div>
        <Footer /> 
      </div>
    )
}